import {
  BP_BOOKING_KEY,
  BP_BOOKING_PARAMS,
  BP_EMAIL_ADDRESS_KEY,
  BP_FIRST_DATA_PAYMENT_FORM_KEY,
  BP_PAYMENT_ERROR_KEY,
} from "../../../constants/balance-payments";
import SessionDataManager from "../../../util/storage-manager";

export default class BalancePaymentError {
  constructor(context) {
    this.context = context;

    this.init();
  }

  init() {
    const bookingDetails = SessionDataManager.getStorageItem(BP_BOOKING_KEY);
    const loginPage = this.context.dataset.balancePaymentLoginPage;

    if (!bookingDetails) {
      window.location.href = loginPage;
      return;
    }

    this.bookingDetails = JSON.parse(bookingDetails);

    const errorMessageElement = this.context.querySelector('[data-balance-payment-error-message]');
    let errorMessage = SessionDataManager.getStorageItem(BP_PAYMENT_ERROR_KEY);

    if (!errorMessage) {
      errorMessage = errorMessageElement.dataset.balancePaymentFailedReason;
    }

    errorMessageElement.innerHTML = errorMessage;
    SessionDataManager.removeStorageItem(BP_EMAIL_ADDRESS_KEY)
    SessionDataManager.removeStorageItem(BP_FIRST_DATA_PAYMENT_FORM_KEY)
    SessionDataManager.removeStorageItem(BP_BOOKING_PARAMS)
    SessionDataManager.removeStorageItem(BP_BOOKING_KEY)
  }
}